import { DATE_PIPE_DEFAULT_OPTIONS } from '@angular/common';

import { MerchantStore } from '../../feature/merchant/merchant.store';

export const provideDatePipeOptions = () => {
	return {
		provide: DATE_PIPE_DEFAULT_OPTIONS,
		useFactory: (merchant: InstanceType<typeof MerchantStore>) => {
			const offset = Math.abs(merchant.merchant()!.timezoneOffset());
			const sign = merchant.merchant()!.timezoneOffset() < 0 ? '-' : '+';
			const hours = offset / 60;
			const minutes = offset % 60;
			const timezone = `${sign}${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;

			return { timezone };
		},
		deps: [MerchantStore],
	};
};
